import React, { createContext, useMemo, useState } from 'react';

import { ChatBotData } from 'proto/ChatBotData';
import { TravelExpertList } from 'proto/TravelExpert/TravelExpert';

import { TravelExpertActions, TravelExpertData } from './types';

export const TravelExpertContext = createContext<TravelExpertData>({
    travelExpertList: TravelExpertList.fromPartial({}),
});

export const TravelExpertActionContext = createContext<TravelExpertActions>({
    updateTravelExpertList() {},
    updateChatBotData() {},
    resetTravelExpertData() {},
});

export const TravelExpertProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [travelExpertList, setTravelExpertList] = useState(
        TravelExpertList.fromPartial({})
    );
    const [chatBotData, setChatBotData] = useState<ChatBotData>();

    const contextValue = useMemo<TravelExpertData>(
        () => ({
            travelExpertList,
            chatBot: chatBotData,
        }),
        [chatBotData, travelExpertList]
    );

    const actionMap = useMemo<TravelExpertActions>(
        () => ({
            updateTravelExpertList: setTravelExpertList,
            updateChatBotData: setChatBotData,
            resetTravelExpertData() {
                setTravelExpertList(TravelExpertList.fromPartial({}));
                setChatBotData(undefined);
            },
        }),
        []
    );

    return (
        <TravelExpertActionContext.Provider value={actionMap}>
            <TravelExpertContext.Provider value={contextValue}>
                {children}
            </TravelExpertContext.Provider>
        </TravelExpertActionContext.Provider>
    );
};
